<template>
	<div>
		<div class="horizontal" style="align-items: center;">
			<div>
				<div v-if="selectedDeviceIndex !== 0" style="margin-left: 20px; cursor: pointer;" @click="changeSelection(devices[selectedDeviceIndex - 1])">
					<div style="margin: 0 20px;"><img src="@/assets/img/_old/arrow_left_active.png"/></div>
				</div>
				<div v-else style="margin-left: 20px; cursor: not-allowed;">
					<div style="margin: 0 20px;"><img src="@/assets/img/_old/arrow_left_active.png"/></div>
				</div>
			</div>
			<div class="horizontal select-device" v-on:click="changeModalState(true)">
				<span style="margin: auto;">{{`${selectedDevice.number} (${selectedDevice.numberOfAlarms})`}}</span>
			</div>
			<div>
				<div v-if="selectedDeviceIndex !== devices.length - 1" style="cursor: pointer;" @click="changeSelection(devices[selectedDeviceIndex + 1])">
					<div style="margin: 0 20px;"><img src="@/assets/img/_old/arrow_right_active.png"/></div>
				</div>
				<div v-else style="cursor: not-allowed;">
					<div style="margin: 0 20px;"><img src="@/assets/img/_old/arrow_right_active.png"/></div>
				</div>
			</div>
		</div>
		<div v-if="modalState" class="devices-dropdown-container" id="devices-dropdown">
			<div v-click-outside="(args) => changeModalState(false, args)" class="devices-dropdown-grid">
				<div v-for="dev in devices">
					<div :class="['device-card', { 'mid-low-alarm' : dev.numberOfAlarms > 0 && dev.areCriticalAlarms === false },  { 'critical-alarm' : dev.areCriticalAlarms === true }, { 'selected-device' : dev.id === selectedDevice.id}]" v-on:click="changeSelection(dev)">
						<b>{{dev.number}}</b>
						<span style="font-size: 12px;">({{dev.numberOfAlarms}})</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getDevicesForSystem } from "../../api/api";

export default {
	name: "DevicesSelect",
	props: {
		systemId: {
			type: String,
			required: true
		},
		preSelectedDevice: {
			type: Object,
			required: false,
			default: null,
		},
		preLoadedDevices: {
			type: Array,
			required: false,
			default: null
		},
		dateFrom: {
			type: Date,
			required: true,
		},
		dateTo: {
			type: Date,
			required: true
		}
	},
	data() {
		return {
			devices: [],
			selectedDevice: {},
			modalState: false,
			selectedDeviceIndex: 0,
		}
	},
	watch: {
		dateFrom(newVal, oldVal){
			this.getData()
		},
		dateTo(newVal, oldVal){
			this.getData()
		}
	},
	methods: {
		async getData() {
			if(this.preLoadedDevices == null || this.preLoadedDevices.length === 0 || this.selectedDevice.id !== undefined){
				let devs = await getDevicesForSystem(this.systemId, this.dateFrom, this.dateTo)
				this.devices = devs.sort((a,b) => a.number - b.number);
			} else {
				this.devices = [...this.preLoadedDevices]
			}

			if(this.selectedDevice.id === undefined) {
				this.selectedDevice = this.preSelectedDevice == null ? this.devices[0] : this.devices[this.devices.findIndex(x => x.id == this.preSelectedDevice.deviceId)]
			} else {
				this.selectedDevice = this.devices[this.devices.findIndex(x => x.id == this.selectedDevice.id)]
			}

			this.selectedDeviceIndex = this.devices.findIndex(x => x.id == this.selectedDevice.id)
		},
		changeSelection(selection) {
			this.selectedDevice = selection
			this.selectedDeviceIndex = this.devices.findIndex(x => x.id == this.selectedDevice.id)
			this.$emit('deviceChanged', this.selectedDevice)
			this.modalState = false
		},
		changeModalState(args) {
			this.modalState = !this.modalState
		}
	},
	mounted: async function() {
		await this.getData()
	}
}
</script>

<style scoped>
.select-device {
	border: solid 1px #ccc;
	border-radius: 5px;
	padding: 0 20px;
	width: 100px;
	height: 34px;
	justify-content: center;
	color: #555;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .08);
}

.select-device:hover {
	border: solid 1px rgba(0, 125, 149, 1);
	cursor: pointer;
}

.devices-dropdown-container {
	position: fixed;
	z-index: 1;
	background-color: rgba(245, 245, 245, 1);
	box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	width: 450px;
	max-height: 50vh;
	overflow-y: auto;
}

.devices-dropdown-grid {
	display: grid;
	grid-template-columns: repeat(6, auto);
	margin: 10px;
}

.device-card {
	padding: 5px;
	height: 30px;
	margin: 5px 5px;
	box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
	-ms-flex-item-align: center;
	text-align: center;
	border-radius: 5px;
	border: 1px white;
	cursor: pointer;
	background-color: #3CD6B1;
	/*font-weight: bolder;*/
}
.device-card:hover {
	background-color: rgba(0, 125, 149, 0.1);
}

.selected-device {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4) 0 0);
	color: white;
}

.critical-alarm {
	background-color: #FF6666;
}

.mid-low-alarm {
	background-color: #FFBD6D;
}
</style>



// WEBPACK FOOTER //
// src/components/Filters/DevicesSelect.vue